import React from "react";

import TranslateIcon from "@mui/icons-material/Translate";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

export const LocaleSelector = ({
  options = [],
  onLocaleChange,
  color = "white",
  locale,
}) => {
  const [localeAnchorEl, setLocaleAnchor] = React.useState(null);
  const localeMenuOpen = Boolean(localeAnchorEl);

  if (!options || options.length === 0) {
    return null;
  }

  const handleLocaleMenuClose = () => {
    setLocaleAnchor(null);
  };
  const handleLocaleMenuClick = (event) => {
    setLocaleAnchor(event.currentTarget);
  };
  const setLocale = (loc) => {
    handleLocaleMenuClose();
    onLocaleChange(loc);
  };
  const LocaleMenu = () => {
    const menu = [];
    for (const [key, value] of Object.entries(options)) {
      menu.push(
        <MenuItem key={key} onClick={() => setLocale(key)}>
          {value}
        </MenuItem>
      );
    }
    return menu;
  };
  return (
    <>
      <IconButton
        id="site-locale"
        aria-controls="site-locale"
        aria-haspopup="true"
        aria-expanded={localeAnchorEl ? "true" : undefined}
        onClick={handleLocaleMenuClick}
        sx={{ color }}
      >
        <TranslateIcon sx={{ color }} />
        &nbsp;&nbsp;{options[locale]}
        {localeAnchorEl ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
      </IconButton>
      <Menu
        id="site-locale"
        aria-labelledby="site-locale"
        anchorEl={localeAnchorEl}
        open={localeMenuOpen}
        onClose={handleLocaleMenuClose}
      >
        <LocaleMenu />
      </Menu>
    </>
  );
};

// export default LocaleSelector;
const MemoizedLocaleSelector = React.memo(LocaleSelector);
export default MemoizedLocaleSelector;
/* 

import React from "react";

import TranslateIcon from "@mui/icons-material/Translate";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
// import { setCookies, getCookie } from "cookies-next";

const locales = {
  en: "English",
  "nb-NO": "Norwegian",
  "de-DE": "German",
  "es-ES": "Spanish",
  "fr-FR": "French",
  // "en-ug": "English (Uganda)",
  "fil-PH": "Filipino",
  "gu-IN": "Gujarati",
  "ms-MY": "Malay",
  "hi-IN": "Hindi",
  "ta-IN": "Tamil",
  "vi-VN": "Vietnamese",
  "zh-CN": "Chinese",
};

export const LocaleSelector = ({ onLocaleChange, locale }) => {
  const [localeAnchorEl, setLocaleAnchor] = React.useState(null);
  const localeMenuOpen = Boolean(localeAnchorEl);

  const handleLocaleMenuClose = () => {
    setLocaleAnchor(null);
  };

  const handleLocaleMenuClick = (event) => {
    setLocaleAnchor(event.currentTarget);
  };

  const setLocale = (loc) => {
    handleLocaleMenuClose();
    onLocaleChange(loc);
  };

  const LocaleMenu = () => {
    const menu = [];
    for (const [key, value] of Object.entries(locales)) {
      menu.push(
        <MenuItem key={key} onClick={() => setLocale(key)}>
          {value}
        </MenuItem>
      );
    }
    return menu;
  };
  return (
    <>
      <IconButton
        id="site-locale"
        aria-controls="site-locale"
        aria-haspopup="true"
        aria-expanded={localeAnchorEl ? "true" : undefined}
        onClick={handleLocaleMenuClick}
      >
        <TranslateIcon />
        &nbsp;&nbsp;{locales[locale]}
      </IconButton>
      <Menu
        id="site-locale"
        aria-labelledby="site-locale"
        anchorEl={localeAnchorEl}
        open={localeMenuOpen}
        onClose={handleLocaleMenuClose}
      >
        <LocaleMenu />
      </Menu>
    </>
  );
};

export default React.memo(LocaleSelector);

*/
